import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../auth/services/auth.service';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, ButtonModule, MenuModule],
  template: `
    <header class="bg-blue-800 dark:bg-slate-900 text-white px-6 py-3 flex justify-between items-center border-b border-blue-900 dark:border-slate-700">
      <div class="flex items-center gap-4">
        <h1 class="text-xl font-bold">Call Avoidance Search</h1>
        @if (authService.isAuthenticated()) {
          <nav class="flex gap-4 ml-8">
            @if (authService.hasGroup('Dashboard')) {
              <a routerLink="/dashboard" class="hover:underline">Dashboard</a>
            }
            @if (authService.hasGroup('Config')) {
              <a routerLink="/config" class="hover:underline">Config</a>
            }
            @if (authService.isAdmin()) {
              <a routerLink="/admin/users" class="hover:underline">Users</a>
              <a routerLink="/admin/groups" class="hover:underline">Groups</a>
            }
          </nav>
        }
      </div>
      <div class="flex items-center gap-4">
        <!-- Theme Toggle -->
        <button
          (click)="themeService.toggleTheme()"
          class="p-2 rounded-lg hover:bg-blue-700 dark:hover:bg-slate-700 transition-colors"
          [title]="themeService.isDark() ? 'Switch to Light Mode' : 'Switch to Dark Mode'">
          @if (themeService.isDark()) {
            <i class="pi pi-sun text-yellow-300"></i>
          } @else {
            <i class="pi pi-moon text-blue-200"></i>
          }
        </button>

        @if (authService.isAuthenticated()) {
          <span class="text-sm">{{ authService.getCurrentUser()?.firstName }} {{ authService.getCurrentUser()?.lastName }}</span>
          @if (authService.isAdmin()) {
            <span class="text-xs bg-yellow-500 text-black px-2 py-0.5 rounded">Admin</span>
          }
          <p-button
            label="Logout"
            severity="secondary"
            size="small"
            (onClick)="onLogout()" />
        }
      </div>
    </header>
  `
})
export class HeaderComponent {
  authService = inject(AuthService);
  themeService = inject(ThemeService);

  onLogout(): void {
    this.authService.logoutAzureAD();
  }
}
